import { createApi } from '@reduxjs/toolkit/query/react';

import {
  DiscountCode,
  Subscription,
  SupplierRegistrationAPIRequest,
  SupplierRegistrationCode,
} from '@scaleup/models';
import { baseQuery } from './baseQuery';

export const landingApi = createApi({
  reducerPath: 'landingApi',
  baseQuery: baseQuery,
  tagTypes: [],
  endpoints: (builder) => ({
    getDiscountCode: builder.query<DiscountCode, string>({
      query: (discountCode) => `/registration/code/discount/${discountCode}`,
      providesTags: [],
    }),
    getRegistrationCode: builder.query<SupplierRegistrationCode, string>({
      query: (registrationCode) => `/registration/code/${registrationCode}`,
      providesTags: [],
    }),
    getStandardSubscription: builder.query<Subscription, void>({
      query: () => `/subscription/supplier/standard`,
      providesTags: [],
    }),
    validateUser: builder.query<void, string>({
      query: (userEmail) => `/registration/user?userEmail=${userEmail}`,
      providesTags: [],
    }),
    validateOrg: builder.query<
      void,
      { city: string; state: string; companyWebsite: string }
    >({
      query: (d) =>  `/registration/org?state=${d.state}&website=${d.companyWebsite}&city=${d.city}`,
    }),
    supplierRegistration: builder.mutation<
      void,
      SupplierRegistrationAPIRequest
    >({
      query: (req) => ({
        url: `/registration/supplier`,
        method: 'POST',
        body: req,
      }),
    }),
  }),
});

export const {
  useLazyGetDiscountCodeQuery,
  useLazyGetRegistrationCodeQuery,
  useLazyValidateOrgQuery,
  useValidateOrgQuery,
  useLazyValidateUserQuery,
  useGetStandardSubscriptionQuery,
  useSupplierRegistrationMutation,
} = landingApi;
